import { eventTypesEnum } from "kubb";
import { startCase } from "lodash-es";
import type React from "react";
import {
  type Option,
  SelectComboField,
} from "../../components/Forms/SelectCombo/SelectCombo";

export default function EventTypeSelect(props: {
  fieldName: string;
}): React.ReactElement {
  const { fieldName, ...rest } = props;

  const options: Option[] = Object.values(eventTypesEnum).map(
    (v: string): Option => {
      return {
        value: v,
        label: startCase(v),
      };
    },
  );

  return (
    <SelectComboField
      options={options}
      fieldName={fieldName}
      {...rest}
      isMulti
    />
  );
}
